import { parseISO, format } from 'date-fns';

// get param date like 2024-04-12 return day : like יום רביעי
export const getHebrewDayName = (date) => {
    var hebrewDay = format(parseISO(date), 'iiii', { locale: require('date-fns/locale/he') });
    return hebrewDay;
}
export const convertToDateTime = (date, time) => {
    const dateTimeString = `${date}T${time}`;
    return new Date(dateTimeString);
}

export const getTimeFromDateTime = (date) => {
    const dateObject = new Date(date);
    const hours = dateObject.getUTCHours().toString().padStart(2, '0');
    const minutes = dateObject.getUTCMinutes().toString().padStart(2, '0');

    const timeFormat = `${hours}:${minutes}`;
    return timeFormat;
};

export const getHebrewMonth = (date) => {
    const dateObj = new Date(date);
    const monthOfYear = ['ינואר', 'פברואר', 'מרץ', 'אפריל', 'מאי', 'יוני', 'יולי', 'אוגוסט', 'ספטמבר', 'אוקטובר', 'נובמבר', 'דצמבר'];
    return monthOfYear[dateObj.getMonth()];
}

export const getDayName = (d) => {
    let day = '';

    switch (d.getDay()) {
        case 0:
            day = "יום א'";
            break;
        case 1:
            day = "יום ב'";
            break;
        case 2:
            day = "יום ג'";
            break;
        case 3:
            day = "יום ד'";
            break;
        case 4:
            day = "יום ה'";
            break;
        case 5:
            day = "יום ו'";
            break;
        case 6:
            day = "יום ש'";
    }

    return day;
};

export const addDays = (date, days) => {
    var result = new Date(date);
    result.setDate(result.getDate() + days);
    return result;
}

export const getTime = (d) => {
    return d.toTimeString().replace(/:\d+ /, ' ').split(' ')[0];
};

export const getDefaultDate = (addDays) => {
    const today = new Date();
    const newDate = new Date(today);
    newDate.setDate(newDate.getDate() + addDays);
    return newDate.toISOString();
};

export const getFormatDate = (d) => {
    d = d instanceof Date ? d : new Date(d);
    var day =  ('0' + d.getDate()).slice(-2);
    var month = ('0' + (d.getMonth() + 1)).slice(-2);
    var year = d.getFullYear();
    return day + '/' + month + '/' + year;
};

export const getFormatDateWithTime = (strDate) => {

    var d = new Date(strDate);

    var month = ('0' + (d.getMonth() + 1)).slice(-2);
    var date = ('0' + d.getDate()).slice(-2);
    var year = d.getFullYear();
    var hours = d.getHours();
    var minutes = d.getMinutes();
    return year + '-' + month + '-' + date + ' ' + d.toTimeString().replace(/:\d+ /, ' ').split(' ')[0];

}

export const getFullDate = () => {

    var d = new Date();

    var month = ('0' + (d.getMonth() + 1)).slice(-2);
    var date = ('0' + d.getDate()).slice(-2);
    var year = d.getFullYear();
    var hours = d.getHours();
    var minutes = d.getMinutes();
    return date + '/' + month + '/' + year + ' ' + d.toTimeString().replace(/:\d+ /, ' ').split(' ')[0];
}


export const formatTimeSlots = (arr) => {
    let newSlotsArr = [];

    for (let i = 0;i < arr.length;i++) {
        let sDate = new Date(arr[i].start);
        let eDate = new Date(arr[i].end);

        let onlyDate = getFormatDate(sDate);
        let startTime = getTime(sDate);
        let endTime = getTime(eDate);
        let dayName = getDayName(sDate);
        let val = dayName + ' ' + onlyDate + '\u00A0\u00A0 ' + endTime + ' - ' + startTime;
        newSlotsArr.push({ key: val, value: val, startDate: arr[i].start, endDate: arr[i].end });
    }

    return newSlotsArr;
};

export const formatIbcSlots = (arr) => {
    let newSlotsArr = [];

    for (let i = 0;i < arr.length;i++) {
        let sDate = new Date(arr[i].start);
        let eDate = new Date(arr[i].end);

        let onlyDate = getFormatDate(sDate);
        let startTime = getTime(sDate);
        let endTime = getTime(eDate);
        let dayName = getDayName(sDate);
        let val = dayName + ' ' + onlyDate + '\u00A0\u00A0 ' + endTime + ' - ' + startTime;
        newSlotsArr.push({ key: val, value: val, startDate: arr[i].start, endDate: arr[i].end, calendarId: arr[i].calendarId });
    }

    return newSlotsArr;
};

export const formatDeliveryTimeSlots = (arr) => {
    let newSlotsArr = [];
    let tempWaitTo = '';
    let tempWaitFrom = '';

    for (let i = 0;i < arr.length;i++) {
        let sDate = new Date(arr[i].lfdat);
        let eDate = new Date(arr[i].lfdat);

        let onlyDate = getFormatDate(sDate);
        let dayName = getDayName(sDate);

        tempWaitTo = arr[i].waitTo.substring(0, arr[i].waitTo.length - 3);
        tempWaitFrom = arr[i].waitFrom.substring(0, arr[i].waitFrom.length - 3);

        let val = dayName + ' ' + onlyDate + '\u00A0\u00A0 ' + tempWaitTo + ' - ' + tempWaitFrom;
        newSlotsArr.push({
            key: val,
            value: val,
            waitFrom: arr[i].waitFrom,
            waitTo: arr[i].waitTo,
            roundName: arr[i].roundName,
            round: arr[i].round,
            lfdat: arr[i].lfdat,
            weekdayL: arr[i].weekdayL,
            pickLocation: arr[i].pickLocation,
        });
    }

    return newSlotsArr;
};

export function compareCurrentTimeToRange(startTimeStamp, endTimeStamp) {
    const currentTime = new Date();

    if (!startTimeStamp && !endTimeStamp) return true;

    if (startTimeStamp && !endTimeStamp) return currentTime >= new Date(startTimeStamp);

    if (!startTimeStamp && endTimeStamp) return currentTime <= new Date(endTimeStamp);

    const startTime = new Date(startTimeStamp);
    const endTime = new Date(endTimeStamp);
    return currentTime >= startTime && currentTime <= endTime;
}

export const convertDateStringToISO = (dateString, isEndDate = false) => {
    if (!dateString) return null;

    if (dateString instanceof Date) {
      const year = dateString.getFullYear();
      const month = String(dateString.getMonth() + 1).padStart(2, '0');
      const day = String(dateString.getDate()).padStart(2, '0');
      const time = isEndDate ? 'T23:59:59' : 'T00:00:00';
      return `${year}-${month}-${day}${time}`;
    }

    if (typeof dateString === 'string' && dateString.includes('T')) {
      return dateString;
    }

    if (typeof dateString === 'string' && dateString.includes('/')) {
      const [day, month, year] = dateString.split('/');
      const time = isEndDate ? 'T23:59:59' : 'T00:00:00';
      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}${time}`;
    }

    return dateString;
};

export const parseToDate = (dateString) => {
  if (!dateString) return null;

  // YYYYMMDD
  if (/^\d{8}$/.test(dateString)) {
    return new Date(
      dateString.slice(0, 4),
      dateString.slice(4, 6) - 1,
      dateString.slice(6, 8)
    );
  }

  // DD.MM.YYYY
  if (/^\d{2}\.\d{2}\.\d{4}$/.test(dateString)) {
    const [day, month, year] = dateString.split('.');
    return new Date(year, month - 1, day);
  }

  // fallback (ISO etc.)
  return new Date(dateString);
};


